import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const businessAPI = {
    async GetBusiness(page, limit=50, startDate="", endDate="", keywordType="", keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Business/GetBusiness?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },
    async GetBusinessCount(startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Business/GetBusinessCount?startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },

    async GetBusinessTotalCount(){
        const responseModel = await JwtAxios.get(`/Business/GetBusinessTotalCount`);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/Business/ExportExcel`,model);
        return responseModel
    },
}